import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams} from 'ionic-angular';
import * as moment from "moment";
import {CalendarComponentOptions} from "ion2-calendar";

/**
 * Generated class for the DatePickerPopoverPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-date-picker-popover',
  templateUrl: 'date-picker-popover.html',
})
export class DatePickerPopoverPage {

  options: CalendarComponentOptions;
  selectedDate: any;
  params: any;


  constructor(public navCtrl: NavController, public navParams: NavParams) {
    moment.updateLocale('de', function () {

    });

    this.params = this.navParams.data;

    this.options = {
      monthPickerFormat: ['JAN', 'FEB', 'MÄR', 'APR', "MAI", "JUN", "JUL", "AUG", "SEP", "OKT", "NOV", "DEZ"],
      weekdays: ["S", "M", "D", "M", "D", "F", "S"],
      monthFormat: 'MMMM YYYY',
      weekStart: 1
    }

    console.log(this.navParams);
    if(this.navParams.get('selectionFilterMax')) {
      this.options.to = this.navParams.get('selectionFilterMax');
    }
    if(this.navParams.get('selectionFilterMin')) {
      this.options.from = this.navParams.get('selectionFilterMin');
      this.selectedDate = this.navParams.get('selectionFilterMin');
    } else {
      this.options.from = new Date();
    }

    if(this.navParams.get('currentSelection')) {
      this.selectedDate = this.navParams.get('currentSelection');
    }

    if(this.params && this.params.pastDateSelect) {
      this.options.from = new Date(2018, 1, 1);
      this.options.to = new Date();
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad DatePickerPopoverPage');
  }

  onChange(event) {
    console.log('onChange event', event);
  }

  accept() {
    if(this.navParams.data.valueUpdated) {
      this.navParams.data.valueUpdated(this.selectedDate);
    }
    this.navCtrl.pop();
  }

  closePopover() {
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/date-picker-popover/date-picker-popover.ts